import { useNavigate } from 'react-router-dom';

import { buildQueryString } from '../Buyer/utils/queryParams';
import { ValidRoutePaths } from '../routing/utils';

export const useSafeNavigate = () => {
  const navigatePage = useNavigate();
  const queryString = buildQueryString();

  const navigate = ({
    to,
    keepParams = true,
  }: {
    to: ValidRoutePaths;
    keepParams?: boolean;
  }) => {
    navigatePage(`${to}${keepParams ? queryString : ''}`);
  };

  return {
    navigate,
  };
};
